import { dailySpinChainId } from '@/constants/shared';
import { RAFFLE_ABI } from '@/network/abi/raffle';
import { useCallback } from 'react';
import { useReadContract } from 'wagmi';

export type PrizeDetails = {
  name: string;
  description: string;
  value: number;
  totalTickets: number;
  isActive: boolean;
  endsAt?: Date;
  winner: `0x${string}` | undefined; // Ensures a valid Ethereum address format
  winnerIndex: number | undefined;
  totalUsers: number;
  claimed: boolean;
  endTimestamp?: bigint;
};

export const useRaffle = () => {
  // Fetch all prizes
  const {
    data: prizesData,
    isLoading: isLoadingPrizes,
    refetch: refetchPrizes,
    error: prizesError,
  } = useReadContract({
    address: import.meta.env.VITE_RAFFLE_CONTRACT_ADDRESS,
    abi: RAFFLE_ABI,
    chainId: dailySpinChainId,
    functionName: 'getPrizeDetails',
    query: {
      refetchOnMount: false,
    },
  });

  // Expose a refresh function for both
  const refetchRaffle = useCallback(() => {
    refetchPrizes?.();
  }, [refetchPrizes]);

  return {
    prizesData: prizesData as PrizeDetails[] | undefined,
    isLoadingPrizes,
    prizesError,
    refetchRaffle,
  };
};
